<app-book *ngIf="showBook"></app-book>
<app-header *ngIf="!showBook"></app-header>
<router-outlet *ngIf="!showBook" (activate)="onActivate($event)"></router-outlet>
<div>
    <app-footer *ngIf="!showBook"></app-footer>
</div>